import closest from 'closest';
import matches from 'matches-selector';

export default class SettingsGroup {
  createPill(data) {
    this.dummyElement.innerHTML = this.pillTemplate;
    let pill = this.dummyElement.firstElementChild;
    let label = pill.querySelector('.vgr-settings-group__pill-label');
    label.textContent = data.label;

    let button = pill.querySelector('button');
    Object.assign(button.dataset, data);
    button.addEventListener('click', this.handlePillRemoveButtonClick);
    let icon = button.querySelector('.vgr-icon');
    icon.setAttribute(
      'aria-label',
      icon.getAttribute('aria-label').replace('%label%', data.label),
    );
    return pill;
  }
  updatePills() {
    this.pillContainer.innerHTML = '';
    let checkboxes = this.checkboxTree.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    // Add a pill for each checkbox, but skip children of checked items
    Array.from(checkboxes).forEach(checkbox => {
      let item = closest(checkbox, '.vgr-checkbox-tree__item');
      let parentItem = closest(item, '.vgr-checkbox-tree__item');
      if (parentItem) {
        let parentCheckbox = parentItem.querySelector('input[type="checkbox"]');
        if (parentCheckbox.checked) {
          // Don’t add a pill if parent is checked
          return;
        }
      }
      this.pillContainer.appendChild(this.createPill(checkbox.dataset));
    });
    this.element
      .querySelector('.vgr-settings-group__no-choices-text')
      .classList.toggle(
        'vgr-settings-group__no-choices-text--visible',
        !this.pillContainer.children.length,
      );
  }
  handlePillRemoveButtonClick = event => {
    this.checkboxTree.checkboxTree.changeCheckboxStatusByLabel(
      event.currentTarget.dataset.label,
      false,
    );
    this.updatePills();
  };
  constructor(element) {
    this.element = element;
    this.dummyElement = document.createElement('div');
    let toggleTreeButton = element.querySelector('.vgr-settings-group__button');
    let details = element.querySelector('.vgr-settings-group__details');
    this.pillContainer = element.querySelector(
      '.vgr-settings-group__choices-inner',
    );
    this.pillTemplate = this.pillContainer.querySelector('script').innerHTML;
    this.checkboxTree = details.querySelector('.vgr-checkbox-tree');
    toggleTreeButton.addEventListener('click', () => {
      // Alternate aria-expanded between "true" and "false"
      details.setAttribute(
        'aria-expanded',
        String(details.getAttribute('aria-expanded') !== 'true'),
      );
    });
    details.addEventListener('change', event => {
      let checkbox = event.target;
      // Drop out if `checkbox` is not a checkbox
      if (!matches(checkbox, 'input[type="checkbox"]')) {
        return;
      }
      this.updatePills();
    });
    this.updatePills();
  }
}
